<template>
  <div :class="$style['pt-counselor-form']">
    <pt-form-list-item label="工号："  :required="true">
      <el-input name="workNumber" data-vv-as="工号" v-validate="'required'" v-model="counselorData.workNumber"
        placeholder="请输入工号"></el-input>
    </pt-form-list-item>
    <pt-form-list-item label="姓名："  :required="true">
      <el-input name="firstName" data-vv-as="姓名" v-validate="'required'" v-model="counselorData.firstName"
        placeholder="请输入姓名"></el-input>
    </pt-form-list-item>
    <template>
      <pt-form-list-item label="执业医院：" :required="true">
        <el-button type="primary" plain @click="selectHospital">选择医院</el-button>
        <div :class="$style['specification-table-div']" class="page-background" v-if="selectHospitalList_info">
          <table :class="$style['specification-table']">
            <th>
            <td>医院名称</td>
            <td>分/子公司</td>
            <td>地区</td>
            <td>操作</td>
            </th>
            <tr v-for="(item,index) in selectHospitalList_info" :key="index">
              <td>{{item.name}}</td>
              <td>{{item.branchName}}</td>
              <td>{{item.address}}</td>
              <td @click="deleteRow(index)" style="color:#EDBE81">移除</td>
            </tr>
          </table>
        </div>
      </pt-form-list-item>
    </template>
    <pt-form-list-item label="职位："  :required="true">
      <position-selector name="positionName" data-vv-as="职位" v-validate="'required'" @positionList="getPositionList"
        v-model="counselorData.position" placeholder="请选择"></position-selector>
    </pt-form-list-item>
    <pt-form-list-item label="办公电话："  :required="true">
      <el-input name="officePhone" data-vv-as="办公电话" v-validate="'required'" v-model="counselorData.officePhone"
        placeholder="请输入办公电话"></el-input>
    </pt-form-list-item>
    <pt-form-list-item label="手机："  :required="true">
      <el-input name="mobile" data-vv-as="手机" v-validate="'required|phone'" v-model="counselorData.mobile"
        placeholder="请输入手机"></el-input>
    </pt-form-list-item>
    <pt-form-list-item label="微信：" >
      <el-input v-model="counselorData.wechatId" placeholder="请输入微信"></el-input>
    </pt-form-list-item>
    <pt-form-list-item label="公司："  :required="true">
      <company-selector name="companyName" data-vv-as="公司" v-validate="'required'" @companyList="getCompanyList"
        v-model="counselorData.company" placeholder="请选择"></company-selector>
    </pt-form-list-item>
    <pt-form-list-item label="照片：">
      <wt-upload-file :action="uploadApi" :data="picture_params" :img-url="publicResourcesUrl"
        v-model="counselorData.headImage" :multiple="false" :class="$style['upload-picture']" name="name">
        <div :class="$style['upload-file-text']" class="main-color">+添加图片</div>
      </wt-upload-file>
      <div :class="$style['upload-tips-text']" class="gray-color">* 建议分辨率：120dpi，图片格式：.jpg、.png；</div>
    </pt-form-list-item>
      <hospital-dialog :dialogVisible="is_hospital" :dialogTitle="hospital_title" @close="closeHospitalDialog"
      @selectHospitalList="selectHospitalList" :selectLabels="selectHospitalList_info"></hospital-dialog>
  </div>
</template>

<script>
import hospitalDialog from 'cps/hospital-and-doctor-manage/pt-doctor-manage/hospital-dialog'
import formMixins from 'mixins/form'
import positionSelector from './position-selector'
import companySelector from './company-selector'
// 组件class前缀
const prefixCls = 'pt-counselor-form'

export default {
  name: 'pt-counselor-form',
  mixins: [formMixins],
  components: {
    positionSelector,
    companySelector,
    hospitalDialog
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      labelWidth: '100px',
      uploadApi: this.$uploadApi,
      publicResourcesUrl: this.$publicResourcesUrl,
      picture_params: {
        resourceName: 'avatar'
      },
      counselorData: this.value ? this.value : { hospitals: [] },
      positionList: [],
      companyList: [],
      is_hospital: false,
      hospital_title: '选择医院',
      selectHospitalList_info: null
    }
  },
  watch: {
    counselorData (val) {
      this.$emit('input', val)
      console.log('-------val', val)
    },
    value (val) {
      this.selectHospitalList_info = val.hospitals
      this.counselorData = val
    },
    'counselorData.company' (val) {
      this.positionList.forEach(item => {
        if (val === item.id) {
          this.counselorData.companyName = item.fullName
        }
      })
    },
    'counselorData.position' (val) {
      this.companyList.forEach(item => {
        if (val === item.id) {
          this.counselorData.positionName = item.name
        }
      })
    },
    'counselorData.mobile' (val) {
      this.counselorData.mobile = val.replace(/\s+/g, '')
    },
    selectHospitalList_info: {
      handler: function (val) {
        let newArr = []
        if (val && val.id) {
          val.forEach(item => {
            newArr.push(item)
            this.counselorData.hospitals = newArr
          })
        }
      }
    }
  },
  methods: {
    deleteRow (index) {
      this.selectHospitalList_info.splice(index, 1)
    },
    selectHospital () {
      this.is_hospital = true
    },
    closeHospitalDialog () {
      this.is_hospital = false
    },
    selectHospitalList (val) {
      this.selectHospitalList_info = val
      let newArr = []
      this.selectHospitalList_info.forEach(item => {
        newArr.push(item)
        this.counselorData.hospitals = newArr
      })
    },
    getCompanyList (val) {
      this.positionList = JSON.parse(JSON.stringify(val.data))
    },
    getPositionList (val) {
      this.companyList = JSON.parse(JSON.stringify(val))
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .pt-counselor-form {
    :global {

      .el-input,
      .el-input__inner {
        max-width: 2.8rem;
      }

      .el-input--suffix .el-input__inner {
        min-width: 2.8rem;
      }

      .el-upload--picture-card,
      .el-upload-list--picture-card .el-upload-list__item {
        width: 117px;
        height: 155px;
      }

      el-textarea,
      .el-textarea__inner {
        width: 500px;
      }

      .wt-upload-file {
        line-height: 0;
        margin-top: 10px;
      }
    }

    .upload-file-text {
      line-height: 155px;
    }
  }
    .specification-table-div {
    margin: 20px 0;
    padding: 30px 50px;
  }

  .specification-table{
    display: table!important;
    width: 100%;
    border-collapse:collapse!important;
    th,tr{
        width: 100%!important;
        max-width: 100%!important;
        display: table-row;
        padding: 0!important;
        list-style-type:none;
        border-bottom: 1px solid #C6C9D3;
        color: #818181
    }
    td{
        text-align: center;
        padding: 10px;
    }
}
</style>
